export default {
  getCompanyId: (state, getters, rootState) => {
    return rootState['$_user'].user.profile.companyid;
  },
  getPagination: (state) => {
    return {
      ...state.paging,
      totalRecords: state.paging.totalItemCount,
      totalPages: state.paging.pageCount,
      pageSize: state.configPaginated.pageSize,
    };
  },
};
